import { FunctionComponent } from 'react';
import { faListOl } from '@fortawesome/pro-duotone-svg-icons';
import { ConfigurationType, IConfigurationValue, LinkedProperties } from '@/utilities/forms/ConfigurationFormProcessor';
import ConfigurationItem, { IConfigurationExpandProps } from './ConfigurationItem';

const ConfigurationFormFieldValue: FunctionComponent<IConfigurationValue & IConfigurationExpandProps> = ({ setExpanded, toggleExpand, expanded, ...item}) => {
    const {
        trialConfiguration,
        formFieldValuePropertyPath,
        formFieldValueMetadata,
        formSectionKey,
        isGlobalConfiguration,
        isTrialConfiguration
    } = item;

    return (
        <ConfigurationItem
            toggleExpand={toggleExpand}
            setExpanded={setExpanded}
            expanded={expanded}
            spacing={
                isGlobalConfiguration ? 
                    formSectionKey ?
                        32 : 24 : 
                    formSectionKey ?
                        40 : 32
            }
            basePropertyPath={formFieldValuePropertyPath!}
            edit
            expandable={false}
            enableable={false}
            linkable={!isTrialConfiguration}
            linkedProperties={LinkedProperties[ConfigurationType.Value]}
            title={formFieldValueMetadata?.name ?? 'Unknown Value'}
            description={`ID: ${formFieldValueMetadata?.id}`}
            type="Field Value"
            typeIcon={faListOl}
            item={item}
        />
    );
}

export default ConfigurationFormFieldValue;